
import React from 'react';
import { ItineraryEvent } from '@/types/itinerary';
import { format, parseISO } from 'date-fns';
import { 
  Card,
  CardContent,
} from '@/components/ui/card';
import { 
  MapPin, 
  CalendarDays, 
  Clock, 
  User, 
  FileText,
  Ticket
} from 'lucide-react';
import { TransportationIcon } from './TransportationIcon';
import { getConfirmationNumber, getCleanDescription, getUserName } from './TransportationUtils';
import { formatTimeTo12Hour } from '@/utils/dateUtils';

interface MobileTransportationCardProps {
  event: ItineraryEvent;
}

const MobileTransportationCard: React.FC<MobileTransportationCardProps> = ({ 
  event 
}) => {
  return (
    <Card className="mb-4 overflow-hidden shadow-sm">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3 border-b pb-2">
          <div className="flex items-center">
            <TransportationIcon event={event} size={18} />
            <span className="font-semibold ml-2 mr-auto">{event.title}</span>
          </div>
          <div className="text-xs text-muted-foreground flex items-center">
            <CalendarDays className="h-3 w-3 mr-1" />
            {format(parseISO(event.date), 'MMM d')}
          </div>
        </div>
        
        <div className="grid grid-cols-1 gap-3 text-sm">
          {event.time && (
            <div className="flex items-center">
              <Clock className="h-3.5 w-3.5 mr-2 text-muted-foreground" />
              <span>{formatTimeTo12Hour(event.time)}</span>
            </div>
          )}
          
          {event.location && (
            <div className="flex items-center">
              <MapPin className="h-3.5 w-3.5 mr-2 text-muted-foreground" />
              <span className="text-sm">{event.location}</span>
            </div>
          )}
          
          <div className="flex items-center">
            <User className="h-3.5 w-3.5 mr-2 text-muted-foreground" />
            <span className="text-sm font-medium">{getUserName(event)}</span>
          </div>
          
          {event.description && getConfirmationNumber(event.description) && (
            <div className="flex items-center">
              <Ticket className="h-3.5 w-3.5 mr-2 text-muted-foreground" />
              <span className="text-sm font-medium">{getConfirmationNumber(event.description)}</span>
            </div>
          )}
          
          {event.description && getCleanDescription(event.description) && (
            <div className="flex items-start">
              <FileText className="h-3.5 w-3.5 mr-2 mt-0.5 text-muted-foreground" />
              <span className="text-sm line-clamp-2">{getCleanDescription(event.description)}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default MobileTransportationCard;
